<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-item label="疾病ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['diseaseId', validatorRules.diseaseId]" :trigger-change="true" dictCode="" placeholder="请选择疾病ID"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.diseaseFileCode')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input :disabled='isCodeDisabled' v-decorator="['code']" :placeholder="$t('label.pleaseEnterTheDiseaseFileCode')" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.diseaseFileDescription')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['name']" :placeholder="$t('label.pleaseEnterADiseaseFileDescription')" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="关联类别(取自数据字典-疾病档案分类）" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['categoryCode']" placeholder="请输入关联类别(取自数据字典-疾病档案分类）"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="疾病说明\描述" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['buffer1']" :placeholder="$t('label.pleaseEnterADiseaseDescription')" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.validOrNot')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['validFlag',{'initialValue': 'Y'}]" :placeholder="$t('label.pleaseChooseWhetherItIsValidOrNot')" ></a-input>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">{{$t('button.submit')}}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"

  export default {
    name: 'EfsMdDiseaseForm',
    components: {
      JFormContainer,
      JDictSelectTag,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        isCodeDisabled: false,
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          diseaseId: {
            rules: [
              { required: true, message: '请输入疾病ID!'},
            ]
          },
        },
        url: {
          add: "/diseaseManageArchive/efsMdDisease/add",
          edit: "/diseaseManageArchive/efsMdDisease/edit",
          queryById: "/diseaseManageArchive/efsMdDisease/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        if(this.model.id){
          this.isCodeDisabled=true
        }else{
          this.isCodeDisabled=false
        }
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'diseaseId','code','name','categoryCode','buffer1','validFlag'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'diseaseId','code','name','categoryCode','buffer1','validFlag'))
      },
    }
  }
</script>